<template>
  <div class="field-item">
    <div class="field-label">
      {{ field.label }}<i v-if="field.fill_status" class="impor">*</i>
    </div>
    <div class="field-control field-birth-row">
      <el-select v-model="year" placeholder="年" clearable class="birth-select birth-year" @change="emitValue">
        <el-option v-for="y in years" :key="y" :label="y" :value="y" />
      </el-select>
      <el-select v-model="month" placeholder="月" clearable class="birth-select" @change="emitValue">
        <el-option v-for="m in 12" :key="m" :label="m" :value="m" />
      </el-select>
      <el-select v-model="day" placeholder="日" clearable class="birth-select" @change="emitValue">
        <el-option v-for="d in 31" :key="d" :label="d" :value="d" />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldBirth',
  props: { field: Object, value: { default: () => ({}) } },
  data () {
    const curY = new Date().getFullYear()
    const years = []
    for (let y = curY; y >= curY - 120; y--) years.push(y)
    return { years, year: '', month: '', day: '' }
  },
  methods: {
    emitValue () {
      this.$emit('input', { bir_year: this.year, bir_month: this.month, bir_day: this.day })
    },
    reset () { this.year = ''; this.month = ''; this.day = '' }
  }
}
</script>

<style scoped>
.field-birth-row { display: flex; gap: 8px; }
.birth-select { flex: 1; min-width: 0; }
.birth-year { flex: 1.5; }
@media screen and (max-width: 768px) {
  .field-birth-row { flex-direction: column; }
  .birth-select { width: 100%; }
}
</style>
